import React, { useMemo, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { useRequestHandler } from '@/hooks/useRequestHandler'

import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser, selectAuthUserUpdateRequestState, updateMyProfile } from '@/redux/reducers/auth.reducer'

import ConclusionSentencesForm, { conclusionSentencesFormHandle, ConclusionSentencesFormValues } from '../components/ConclusionSentencesForm'

import { isStaff } from '@/utils/type-guards'

export default function ConclusionSentencesFormContainer() {
  const profileFormRef = useRef<conclusionSentencesFormHandle>(null)
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const { dispatch, requestTracker: authUserUpdateRequestTracker } = useRequestHandler({
    onSuccess: () => {
      enqueueSnackbar(t('notification.authUser.update.success'), { variant: 'success' })
      profileFormRef.current?.toggleEditable()
    },
    onError: () => enqueueSnackbar(t('notification.authUser.update.error'), { variant: 'error' }),
    requestTrackerSelector: selectAuthUserUpdateRequestState,
  })

  const authUser = useAppSelector(selectAuthUser)

  const profileFormInitialValues = useMemo(
    () => ({
      sentences: isStaff(authUser) ? (authUser.conclusionSentences ?? []) : [],
    }),
    [authUser]
  )

  const handleModifyProfile = (values: ConclusionSentencesFormValues) => {
    dispatch(updateMyProfile({ conclusionSentences: values.sentences }))
    console.log(values)
  }

  return (
    <ConclusionSentencesForm
      ref={profileFormRef}
      onSubmit={handleModifyProfile}
      initialValues={profileFormInitialValues}
      isSubmitting={authUserUpdateRequestTracker.loading}
    />
  )
}
